import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { StatisticState } from "./types";

export const state: StatisticState = {
  telegramOtpStatisticDetail: [],
  telegramOtpStatisticGroup: [],
  telegramOtpGroupings: {
    telegramOtpGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    telegramOtpGroupOptionally: [
      'broker_account_login',
      'originator',
      'message_type',
      'template_id',
  ],
  },
};

export const telegramOtpStatistic: Module<StatisticState, RootState> = {
  state,
  actions,
  getters,
  mutations,
};
